import React from "react";
import { css } from "emotion";

const Loader = props => {
  return (
    <div
      className={css`
        text-align: center;
        margin-top: 80px;
      `}>
      Chargement en cours...<br/>
      <img alt='Chargement' src={require('../../../image/loading.gif')} style={{width:30,height:30, marginTop: 50}}/>
    </div>
  );
};

export default Loader;
